
@if (isLoading) {
  <div class="pageLoader">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
<div class="row">

  <div class="col-md mb-1" >
    <a href="#"> My User</a>
    <span appActionTooltip [pTooltip]="!enableAddTime ? 'You can only add availability for your own account — select yourself in the user dropdown to add time.' : 'Add availability time'" [actionDisabled]="!enableAddTime" style="float: right;"><button [disabled]="!enableAddTime" class="btn btn-success" (click)="addTime()">Add Time</button></span>
    <!-- <select *ngIf="isAdminUser" class="form-status-select" [(ngModel)]="selectedUserId"
    (change)='onUserChange()' title="My Projects">
    <option  value="" >Select User</option>
    <option *ngFor="let user of usersList" [ngValue]="user.id">{{user.mainEmail}}</option>
  </select> -->
  @if (isAdminUser) {
    <p-dropdown
      class="form-status-select"
      [options]="usersList"
      [(ngModel)]="selectedUserId"
      optionLabel="mainEmail"
      optionValue="id"
      [showClear]="true"
      [filter]="true"
      [style]="{'width':'100%'}"
      (onChange)="onUserChange()"
      placeholder="Select User">
    </p-dropdown>
  }
</div>
<!-- Your FullCalendar component or other content here -->
<full-calendar #calendar [options]="calendarOptions" (eventRender)="calendarEventRender($event)">
</full-calendar>
</div>
<p-dialog [(visible)]="addTimeDialogue" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
  [style]="{width: '85%'}" [contentStyle]="{'padding-bottom.px': pickerReserve}" [header]="title"
  [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <div class="card">
      <div class="card-body">
        @if (timeInvalid) {
          <div class="text-danger mb-3">Total entered time should not exceed 12 hours</div>
        }
        @if (saveError) {
          <div class="text-danger mb-3">{{ saveError }}</div>
        }
        <div class="row mb-3">
          <div class="col-sm-4">
            <label class="form-label">Select Dates Range</label><span style="color:var(--al-danger);">*</span>
            <p-calendar appendTo="body" (onShow)="reservePickerSpace($event)" (onClose)="releasePickerSpace($event)"  [disabledDays]="[0,6]" [minDate]="defaultDate" [(ngModel)]="selectedDates"  selectionMode="range" >
            </p-calendar>
            @if (noDateRange && !selectedDates) {
              <span style="color:var(--al-danger)">Please select any Date to proceed</span>
            }
            <!-- [disabledDays]="[0,6]" -->
          </div>
          <div class="col-sm-4 form-check mt-5">
            <input class="form-check-input" type="checkbox" id="excludeSaturday" [(ngModel)]="excludeSaturday">
            <label class="form-check-label" for="excludeSaturday">
              Exclude Saturdays
            </label>
          </div>
          <div class="col-sm-4 form-check mt-5">
            <input class="form-check-input" type="checkbox" id="excludeSunday" [(ngModel)]="excludeSunday">
            <label class="form-check-label" for="excludeSunday">
              Exclude Sundays
            </label>
          </div>
        </div>
        <div class="row" >
          <div class="col-sm-12">
            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" id="notAvailable" [(ngModel)]="notAvailable">
              <label class="form-check-label" for="notAvailable">
                Not Available
              </label>
            </div>
          </div>
          <div class="col-sm-4">
            <label for="assignProject" class="form-label">Morning Time (12:00am-12:00pm)(HH:MM)</label>
            <p-calendar appendTo="body" (onShow)="reservePickerSpace($event)" (onClose)="releasePickerSpace($event)" [disabled]="notAvailable" [showTime]="true" hourFormat="24" [timeOnly]="true"
              [(ngModel)]="mrgTimeDate" [maxDate]="maxMorningHours" [defaultDate]="defaultTime">
            </p-calendar>
            <small class="form-text text-muted d-block">Max 12 hours total per day</small>
            @if (mrgTimeInvalid) {
              <span style="color:var(--al-danger)">Morning Time should not exceed 12 hours</span>
            }
          </div>

          <div class="col-sm-4">
            <label for="assignProject" class="form-label">Afternoon Time (12:00pm-5:00pm)(HH:MM)</label>
            <p-calendar appendTo="body" (onShow)="reservePickerSpace($event)" (onClose)="releasePickerSpace($event)" [disabled]="notAvailable" [showTime]="true" hourFormat="24" [timeOnly]="true"
              [(ngModel)]="aftTimeDate" [maxDate]="maxAfternoonHours" [defaultDate]="defaultTime">
            </p-calendar>
            @if (aftTimeInvalid) {
              <span style="color:var(--al-danger)">Afternoon Time should not exceed 5 hours</span>
            }
          </div>

          <div class="col-sm-4">
            <label for="assignProject" class="form-label">Evening Time (5:00pm-12:00am)(HH:MM)</label>
            <p-calendar appendTo="body" (onShow)="reservePickerSpace($event)" (onClose)="releasePickerSpace($event)" [disabled]="notAvailable" [showTime]="true" hourFormat="24" [timeOnly]="true"
              [(ngModel)]="evnTimeDate" [maxDate]="maxEveningHours" [defaultDate]="defaultTime">
            </p-calendar>
            @if (evnTimeInvalid) {
              <span style="color:var(--al-danger)">Evening Time should not exceed 7 hours</span>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-4" style="float: right;">
      <div class="button-items" style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;">
        <span appActionTooltip [actionTooltipDelay]="0" [pTooltip]="timeValidationError || 'Save availability for the selected date range'" [actionDisabled]="!!timeValidationError">
          <button class="btn btn-primary" [disabled]="!!timeValidationError" (click)="updateMultipleAvailable()"> Update @if (btnLoading) {
            <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
          }</button>
        </span>
        <a class="btn btn-secondary" pTooltip="Discard changes and close" appActionTooltip (click)="closeDialog()"> Cancel </a>

        <!-- <a class="btn btn-info" (onClick)="updateAvailable()"> Update <i
        *ngIf="btnLoading" style="margin-left: 7px;"
      class="fa fa-solid fa-sync fa-spin"></i></a>
      <a class="btn btn-warning" (click)="closeDialog()"> Cancel </a> -->
    </div>
  </div>
</ng-template>
</p-dialog>
<p-dialog [(visible)]="dialogFlag" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
  [style]="{width: '85%'}" [contentStyle]="{'padding-bottom.px': pickerReserve}" [header]="title"
  [modal]="true" styleClass="p-fluid">
  <!--
  <p-dialog header="Schedule new appointment"
    [(visible)]="displayAddAppointment"
    modal="modal"> -->
    <ng-template pTemplate="content">
      <div class="card">
        <div class="card-body">
          @if (timeInvalid) {
          <div class="text-danger mb-3">Total entered time should not exceed 12 hours</div>
          }
          @if (saveError) {
            <div class="text-danger mb-3">{{ saveError }}</div>
          }
          <div class="row" >
            <div class="col-sm-12">
              <div class="form-check mb-3">
                <input class="form-check-input" type="checkbox" [(ngModel)]="notAvailable">
                <label class="form-check-label" for="formCheck1">
                  Not Available
                </label>
              </div>
            </div>
            <div class="col-sm-4">
              <label for="assignProject" class="form-label">Morning Time (12:00am-12:00pm)(HH:MM)</label>
              <p-calendar appendTo="body" (onShow)="reservePickerSpace($event)" (onClose)="releasePickerSpace($event)" [disabled]="notAvailable" [showTime]="true" hourFormat="24" [timeOnly]="true"
                [(ngModel)]="mrgTimeDate" [maxDate]="maxMorningHours" [defaultDate]="defaultTime">
              </p-calendar>
              @if (mrgTimeInvalid) {
                <span style="color:var(--al-danger)">Morning Time should not exceed 12 hours</span>
              }
            </div>

            <div class="col-sm-4">
              <label for="assignProject" class="form-label">Afternoon Time (12:00pm-5:00pm)(HH:MM)</label>
              <p-calendar appendTo="body" (onShow)="reservePickerSpace($event)" (onClose)="releasePickerSpace($event)" [disabled]="notAvailable" [showTime]="true" hourFormat="24" [timeOnly]="true"
                [(ngModel)]="aftTimeDate" [maxDate]="maxAfternoonHours" [defaultDate]="defaultTime">
              </p-calendar>
              @if (aftTimeInvalid) {
                <span style="color:var(--al-danger)">Afternoon Time should not exceed 5 hours</span>
              }
            </div>

            <div class="col-sm-4">
              <label for="assignProject" class="form-label">Evening Time (5:00pm-12:00am)(HH:MM)</label>
              <p-calendar appendTo="body" (onShow)="reservePickerSpace($event)" (onClose)="releasePickerSpace($event)" [disabled]="notAvailable" [showTime]="true" hourFormat="24" [timeOnly]="true"
                [(ngModel)]="evnTimeDate" [maxDate]="maxEveningHours" [defaultDate]="defaultTime">
              </p-calendar>
              @if (evnTimeInvalid) {
                <span style="color:var(--al-danger)">Evening Time should not exceed 7 hours</span>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4" style="float: right;">
        <div class="button-items" style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;">
          <span appActionTooltip [actionTooltipDelay]="0" [pTooltip]="timeValidationError || 'Save availability for this day'" [actionDisabled]="!!timeValidationError">
            <button class="btn btn-primary" [disabled]="!!timeValidationError" (click)="updateAvailable()"> Update @if (btnLoading) {
              <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
            }</button>
          </span>
          <a class="btn btn-secondary" pTooltip="Discard changes and close" appActionTooltip (click)="closeDialog()"> Cancel </a>

          <!-- <a class="btn btn-info" (onClick)="updateAvailable()"> Update <i
          *ngIf="btnLoading" style="margin-left: 7px;"
        class="fa fa-solid fa-sync fa-spin"></i></a>
        <a class="btn btn-warning" (click)="closeDialog()"> Cancel </a> -->
      </div>
    </div>
  </ng-template>
</p-dialog>
